export const breakpoints = {
    TABLET_BREAKPOINT: '640px',
    DESKTOP_BREAKPOINT: '866px',
    XLARGE_BREAKPOINT: '1200px',
    XXLARGE_BREAKPOINT: '115rem',
  };